import { Injectable } from '@angular/core';
import { FilterExportRequest } from '@src/app/shared/backend/clients';
import { Observable } from 'rxjs';

export interface ExportOptions {
  fileName?: string;
  fileType?: string;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  exportData(
    rawFilter: any,
    dateRange: [Date, Date] | null,
    exportFn: (payload: FilterExportRequest) => Observable<any>,
    options?: ExportOptions
  ) {

    // remove unnecessary props: pageSize, pageNumber, sort
    const { pageSize, pageNumber, sort, ...payloadFilters } = rawFilter;

    // add fromDate && toDate to the payload
    let fromDate, toDate;
    if (dateRange && dateRange.length === 2) {
      const start = dateRange[0];
      const end = dateRange[1];

      fromDate = new Date(Date.UTC(
        start.getFullYear(),
        start.getMonth(),
        start.getDate(),
        0, 0, 0, 0
      ));

      toDate = new Date(Date.UTC(
        end.getFullYear(),
        end.getMonth(),
        end.getDate(),
        23, 59, 59, 999
      ));
    }

    if (fromDate && toDate) {
      (payloadFilters as any).fromDate = fromDate.toISOString();
      (payloadFilters as any).toDate = toDate.toISOString();
    }

    const exportPayload: FilterExportRequest = {
      filters: payloadFilters.filters || null,
      fromDate: (payloadFilters as any).fromDate,
      toDate: (payloadFilters as any).toDate,
      exportName: options?.fileName,
      fileType: options?.fileType
    };

    // call the provided export endpoint and subscribre to the observable
    exportFn(exportPayload).subscribe({
      next: () => options?.onSuccess?.(),
      error: (err) => options?.onError?.(err)
    });
  }
}
